import { Component, OnInit } from '@angular/core';
import { environment } from '@env/environment';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { LoginDisclaimerComponent } from '@app/shared/disclaimer/login-disclaimer/login-disclaimer.component';
import { AccountService } from '@app/core/services/Common/account.service';

@Component({
  selector: 'sa-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.css']
})
export class FooterComponent implements OnInit {

  appname: string;
  date: Date;
  bsModalRef: BsModalRef;
  config = {
    keyboard: false,
    backdrop: true,
    ignoreBackdropClick: true,
    animated: true,
    centered: false,
    class: "modal-lg"
  };

  constructor(private accountService: AccountService, private modalService: BsModalService,) {
    this.appname = environment.appname;
    this.accountService.checkUserConsent.subscribe(res => {
      console.log(res);
      if (res) {
          this.bsModalRef = this.modalService.show(LoginDisclaimerComponent, this.config);
      }
    },
      err => {
        console.log(err);
      });
  }

  ngOnInit() {
    this.date = new Date();
  }

}
